import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Cart } from './Cart';
import { LanguageSelector } from './LanguageSelector';
import { Container, Group, Anchor, Burger, Box } from '@mantine/core';
import { useLanguage } from '@/context/LanguageContext';

interface HeaderProps {
  mobileOpened: boolean;
  toggleMobile: () => void;
}

export const Header: React.FC<HeaderProps> = ({ mobileOpened, toggleMobile }) => {
  const { t } = useLanguage();
  const location = useLocation();

  const navLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/products', label: t('nav.products') },
    { to: '/about-us', label: t('nav.aboutUs') },
    { to: '/contact', label: t('footer.contactUs') },
  ];

  return (
    <Container size="xl" h="100%">
      <Group justify="space-between" align="center" h="100%">
        {/* Logo */}
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <img
            src="/img/luxelo-high-resolution-logo1.png"
            alt="Luxelo Logo"
            style={{ height: '40px', width: 'auto', objectFit: 'contain' }}
          />
        </Link>

        {/* Desktop Navigation */}
        <Group gap="xl" visibleFrom="sm">
          {navLinks.map((link) => (
            <Anchor
              key={link.to}
              component={Link}
              to={link.to}
              size="md"
              c={location.pathname === link.to ? 'dark' : 'dimmed'}
              fw={location.pathname === link.to ? 600 : 400}
              underline="never"
              style={{
                transition: 'color 0.2s ease',
              }}
            >
              {link.label}
            </Anchor>
          ))}
        </Group>

        {/* Right side: Language, Cart, Burger */}
        <Group gap="md">
          <Box visibleFrom="xs">
            <LanguageSelector />
          </Box>
          <Cart />
          <Burger
            opened={mobileOpened}
            onClick={toggleMobile}
            hiddenFrom="sm"
            size="sm"
            aria-label="Toggle navigation"
          />
        </Group>
      </Group>
    </Container>
  );
};
